import {ILocalizationDictionary} from "./types";
import {trackNotFoundLocalizationKey} from "./trackNotFoundLocalizationKey";
import {ILocalizationSnapshot} from "../../store/common/types";

let localizationDictionary: ILocalizationDictionary = {
    "mainmenu.header": "QuizzLand",
    "loadingcover.header": "Loading",
    "loadingcover.failed": "Whoops, something went wrong...",
    "loadingcover.failed.text": "Unexpected Error",
};

export function initializeLocalizationDictionary(localizationSnapshot: ILocalizationSnapshot) {
    if (!localizationSnapshot || !localizationSnapshot.items)
        return;

    localizationDictionary = localizationSnapshot.items;
}

export default function i18n(key: string) {
    const localizedString = localizationDictionary[key];
    if (localizedString)
        return localizedString;

    trackNotFoundLocalizationKey(key);

    return key;
};